const sortByKey = (arr: any[], key: string) => {
	return arr.sort((a, b) => {
		const valA = a[key];
		const valB = b[key];

		if (valA === null || valA === undefined) {
			return 1;
		};

		if (valB === null || valB === undefined) {
			return -1;
		};

		if (typeof valA === 'string' && typeof valB === 'string') {
			return valA.localeCompare(valB);
		}

		return valA > valB ? 1 : valA < valB ? -1 : 0;
	});
};

export const getUniqueArray = (arr: any[], key1: string, key2: string) => {
	const uniqueMap = new Map();
	arr.forEach(item => {
		const uniqueKey = `${item[key1]}-${item[key2]}`;
		if (!uniqueMap.has(uniqueKey)) {
			uniqueMap.set(uniqueKey, item);
		}
	});
	return Array.from(uniqueMap.values());
};

export const formatPayToParties = (payToParties: any[]) : any => {
	const modifiedPayToParties = payToParties.map((payToParty: any) => {
		return {
			...payToParty,
			'interCompany': !payToParty.interCompany || payToParty.interCompany.toLowerCase() === 'n' ? '-' : payToParty.interCompany
		};
	});

	const filteredVendorsOptions = modifiedPayToParties
		.filter((vendor:any) => {
			return vendor.vendorCode && vendor.vendorName;
		})
		.map((vendor:any) => ({
			label: `${vendor.vendorCode} - ${vendor.vendorName}`,
			value: vendor.vendorCode,
		}));

	const sortedPayToParties = sortByKey(filteredVendorsOptions, 'label');	
	return getUniqueArray(sortedPayToParties, 'label', 'value');
};